













































































import { Component, Prop, Vue } from "@/shared/vuepack";
import { hsabExpenseOriginatorTypeMap, ManagedExpenseResponse } from "@/shared/types";
import moment from "moment/moment";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import Pill from "@/shared/components/ui/Pill.vue";
import { expenseCategoryIcon, expenseSourceIcon } from "@/shared/awesomeIconMapper";

import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import HsabExpenseReimbursementStatusPill from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseReimbursementStatusPill.vue";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";

@Component({
  components: {
    HsabExpenseReimbursementStatusPill,
    Pill,
    CurrencyAmount
  }
})
export default class HsabExpenseCardRowContent extends Vue {
  hsabAccountsStore = useHsabAccountsStore();
  expenseCategoryIcon = expenseCategoryIcon;
  expenseSourceIcon = expenseSourceIcon;
  hsabExpenseOriginatorTypeMap = hsabExpenseOriginatorTypeMap;

  @Prop({ required: true })
  managedExpense: ManagedExpenseResponse;

  @Prop()
  showPlanName: boolean;

  @Prop({ default: false })
  showScheduleDescription: boolean;

  @Prop({ default: true })
  showSource: boolean;

  @Prop({ default: false })
  showCategory: boolean;

  @Prop()
  forceSmallScreen: boolean;

  get formattedDate (): string {
    if (!isNullEmptyOrUndefined(this.managedExpense.dateOfServiceEnd)) {
      const start = moment(this.managedExpense.dateOfService);
      const end = moment(this.managedExpense.dateOfServiceEnd);

      if (start.isSame(end)) {
        return start.format("MMM D, YYYY");
      }

      if (start.year() === end.year()) {
        return start.format("MMM D") + " - " + end.format("MMM D, YYYY");
      }
      return start.format("MMM D, YYYY") + " - " + end.format("MMM D, YYYY");
    }
    return moment(this.managedExpense.dateOfService).format("MMM D, YYYY");
  }

  get formattedOriginator () {
    if (this.managedExpense.originator) {
      return this.hsabExpenseOriginatorTypeMap[this.managedExpense.originator];
    }
    return "Unknown";
  }

  get isDisplayTextHalfWidth () {
    return this.showPlanName || this.showScheduleDescription;
  }
}
